// extracted by mini-css-extract-plugin
export default {"wrapper":"evalution-info_wrapper__ekkTz","avatar":"evalution-info_avatar__hxRZc","info":"evalution-info_info__bkHFQ"};